export interface EnvironmentVariables {
  readonly appsyncEndpoint: string;
  readonly awsAccount: string;
  readonly awsRegion: string;
  readonly cloudFrontDomain: string;
  readonly cloudFrontProtocol: string;
  readonly identifyPoolDomain: string;
  readonly identityPoolId: string;
  readonly stage: string;
  readonly userPoolClientId: string;
  readonly userPoolId: string;
}

export const envVariables: EnvironmentVariables = {
  awsAccount: '945258552535',
  identityPoolId: 'us-east-1:e3439fdf-dfed-4822-bb4b-fba9327fa571',
  userPoolClientId: '5v33bb6dfmrubbmelphge33n4l',
  userPoolId: 'us-east-1_mccV9FlOc',
  identifyPoolDomain: 'acs-silencio-gamma.auth.us-east-1.amazoncognito.com',
  awsRegion: 'us-east-1',
  stage: 'beta',
  cloudFrontProtocol: 'https',
  cloudFrontDomain: 'd2s17von3krlyy.cloudfront.net',
  appsyncEndpoint: 'api.beta.device-rename.acs.amazon.dev',
};
